import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Icon, SocialIcon } from 'react-native-elements';
import { Linking } from 'expo';

import { deviceWidth } from '../helpers/deviceHelper';
import { useNavigation } from '@react-navigation/native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { AntDesign } from '@expo/vector-icons';

const twitterUsername = 'edgw_music';

const styles = StyleSheet.create({
  sectionContainer: {
    backgroundColor: '#f3f4f4',
  },
  orgIntroContainer: {
    padding: deviceWidth * 0.05,
    justifyContent: 'center',
    alignItems: 'center',
  },
  orgName: {
    fontSize: 30,
    fontFamily: 'MPLUS1p_400Regular',
  },
  orgDetail: {
    fontFamily: 'MPLUS1p_100Thin',
  },
  introText: {
    fontSize: 20,
  },
  artistsLinkContainer: {
    // borderColor: 'red',
    // borderWidth: 3,
    justifyContent: 'center',
    padding: deviceWidth * 0.05,
    textDecorationLine: 'underline',
  },
  artistsLinkText: {
    fontFamily: 'MPLUS1p_300Light',
    fontSize: 20,
  },
  deliveryContainer: {
    // borderColor: 'red',
    // borderWidth: 3,
    padding: deviceWidth * 0.05,
  },
  deliveryHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  deliveryHeaderText: {
    marginLeft: deviceWidth * 0.05,
    fontFamily: 'MPLUS1p_300Light',
    fontSize: 20,
    textDecorationLine: 'underline',
  },
  deliveryDetailText: {
    fontFamily: 'MPLUS1p_100Thin',
    // fontStyle: 'italic',
  },
  contactContainer: {
    // borderColor: 'red',
    // borderWidth: 3,
    flexDirection: 'row',
    alignItems: 'center',
    padding: deviceWidth * 0.05,
  },
  contactText: {
    marginLeft: deviceWidth * 0.05,
    fontFamily: 'MPLUS1p_300Light',
    fontSize: 20,
    textDecorationLine: 'underline',
  },
  socialIconContainer: {
    backgroundColor: 'white',
    // borderColor: 'red',
    // borderWidth: 3,
    // padding: deviceWidth * 0.05,
  },
});

export default function About() {
  const navigation = useNavigation();
  return (
    <View style={styles.sectionContainer}>
      <View style={styles.orgIntroContainer}>
        <Text style={styles.orgName}>江戸川演奏家協会</Text>
        <Text style={styles.orgDetail}>
          "江戸川演奏家協会"は、【江戸川区新人演奏会オーディション
          専門の部】に合格し、同演奏会に出演した有志により設立されたプロフェッショナルの演奏家団体です。
          当協会は、江戸川区より後援をいただいている江戸川区音楽協議会の傘下団体でもあります。1991年5月に《第1回ホープフルコンサート》を開催。2021年に設立30周年を迎えます。会員は、国内外で研鑽を積んだ者、数々のコンクールの入賞歴のある者、後進の指導に意欲的に取り組む者…等、地域の音楽の発展に貢献すべく、大変幅広く活動を行なっております。世代を越えて音楽の楽しさを感じていただきたい…という思いのもと、近年では、乳幼児とそのご家族を対象とした《0さいからのコンサート》を開催し、好評を博しております。
        </Text>
        {/* <Text style={styles.introText}>私達は</Text> */}
      </View>
      <TouchableOpacity
        onPress={() => {
          navigation.navigate('Artists');
        }}
      >
        <View style={styles.artistsLinkContainer}>
          <Text style={styles.artistsLinkText}>所属演奏家一覧</Text>
        </View>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          Linking.openURL('mailto:edogawa-music-2015@ezweb.ne.jp');
        }}
      >
        <View style={styles.deliveryContainer}>
          <View style={styles.deliveryHeaderContainer}>
            <Icon name="truck" type="feather" size={40} />
            <Text style={styles.deliveryHeaderText}>
              {'音楽宅配便（出張演奏）'}
            </Text>
          </View>
          <View>
            <Text style={styles.deliveryDetailText}>
              私共の音楽をデリバリーいたします。ご要望に併せて時間や楽器の編成等、公演内容も多種多様にお応えします{' '}
            </Text>
          </View>
        </View>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          Linking.openURL('mailto:edogawa-music-2015@ezweb.ne.jp');
        }}
      >
        <View style={styles.contactContainer}>
          <Icon name="mail" type="feather" size={40} />
          <Text style={styles.contactText}>お問い合わせ</Text>
        </View>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          // Linking.openURL(`twitter://user?screen_name=${twitterUsername}`);
          // Linking.openURL(`twitter://user?screen_name=${twitterUsername}`);
          Linking.openURL('https://twitter.com/edgw_music');
        }}
      >
        <View style={styles.socialIconContainer}>
          <SocialIcon type="twitter" />
        </View>
      </TouchableOpacity>
    </View>
  );
}
